'use client';

import { StatsSection as HomeStatsSection } from 'app/components/stats-section/stats-section';
import { useTranslation } from 'app/i18n/client';
import { ContainerTwoColumns } from 'components/container-two-column/container-two-column';
import { TextLockUp } from 'components/text-lock-up/text-lock-up';
import { useLocale } from 'next-intl';
import css from './stats-section.module.css';
function StatsSection() {
  const locale = useLocale();
  const {
    t
  } = useTranslation(locale, 'channelpartners');
  return <ContainerTwoColumns width="lg" breakAbove="xlg" padded data-sentry-element="ContainerTwoColumns" data-sentry-component="StatsSection" data-sentry-source-file="stats-section.tsx">
            <ContainerTwoColumns.BodyContainer className={css.copy} data-sentry-element="unknown" data-sentry-source-file="stats-section.tsx">
                <TextLockUp size="lg" title={t('numbers.title')} data-sentry-element="TextLockUp" data-sentry-source-file="stats-section.tsx" />
            </ContainerTwoColumns.BodyContainer>
            <HomeStatsSection data-sentry-element="HomeStatsSection" data-sentry-source-file="stats-section.tsx" />
        </ContainerTwoColumns>;
}
export { StatsSection };